<template>
  <app-layout>
    <accessibility-statement />
  </app-layout>
</template>

<script>
import AppLayout from '@/components/Layouts/AppLayout.vue';
import AccessibilityStatement from '@/components/Views/AccessibilityStatement.vue';

export default {
  name: 'AccessibilityStatementLayout',
  components: {
    AppLayout,
    AccessibilityStatement
  },
  metaInfo() {
    return {
      title: 'Accessibility Statement - GOZ',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'GOZ accessibility statement and compliance information for users with disabilities.'
        }
      ]
    };
  }
};
</script>